import { IDynamicSubmitFieldProps } from "@view/common/DynamicForm/DynamicFormContracts";
import styles from "./LoginSubmitFieldWithBack.module.css";
import Button from "../Components/Button";
import lumniPortalNavigation from "../Navigation/lumniPortalNavigation";

export interface ILoginSubmitFieldWithBackProps extends IDynamicSubmitFieldProps {
}

const LoginSubmitField = (props: ILoginSubmitFieldWithBackProps) => {
  return (
    <div className={styles.root}>
      <a className={styles.forgotPassword} href={lumniPortalNavigation.lostPaswordRecovery} target="_blank" rel="noopener noreferrer">
        <span>Olvidé mi contraseña</span>
      </a>
      <Button
        className={styles.submitButton}
        variant="primary"
        type="button"
        disabled={props.disabled}
        onClick={props.onSubmit}
        loading={props.loading}
      >
        {props.label}
      </Button>
    </div>
  );
};

export default LoginSubmitField;
